import React from 'react';

const COLS = [
  { key: 'id',               label: 'ID',          sortable: true,  width: 70  },
  { key: 'logo',             label: '',            sortable: false, width: 56  },
  { key: 'company_name',     label: 'Empresa',     sortable: true               },
  { key: 'nit',              label: 'NIT',         sortable: true,  width: 130 },
  { key: 'user_owner_email', label: 'Admin email', sortable: false             },
  { key: 'plan',             label: 'Plan',        sortable: false, width: 140 },
  { key: 'records_count',    label: 'Registros',   sortable: true,  width: 110 },
  { key: 'size_count',       label: 'Storage',     sortable: true,  width: 110 },
  { key: 'tenant_state',     label: 'Estado',      sortable: true,  width: 120 },
  { key: 'created_at',       label: 'Creado',      sortable: true,  width: 110 },
];

export default function ClientsTable({
  rows, loading, error, sortField, sortDir, onSort, onRowClick
}) {
  if (error) {
    return (
      <div className="cv2-error">
        <i className="fas fa-exclamation-triangle" /> Error: {error}
      </div>
    );
  }

  return (
    <div className="cv2-table-wrap">
      <table className="cv2-table">
        <thead>
          <tr>
            {COLS.map(col => (
              <th
                key={col.key}
                style={col.width ? { width: col.width } : undefined}
                className={`${col.sortable ? 'cv2-th--sortable' : ''} ${sortField === col.key ? 'cv2-th--active' : ''}`}
                onClick={() => col.sortable && onSort(col.key)}
              >
                <span>{col.label}</span>
                {col.sortable && sortField === col.key && (
                  <i className={`cv2-sort fas fa-caret-${sortDir === 'ASC' ? 'up' : 'down'}`} />
                )}
              </th>
            ))}
            <th className="cv2-th--actions" />
          </tr>
        </thead>
        <tbody>
          {loading && rows.length === 0 && (
            Array.from({ length: 8 }).map((_, i) => (
              <tr key={`sk-${i}`} className="cv2-tr--skeleton">
                {COLS.map(c => <td key={c.key}><span className="cv2-sk-bar" /></td>)}
                <td />
              </tr>
            ))
          )}

          {!loading && rows.length === 0 && (
            <tr>
              <td colSpan={COLS.length + 1} className="cv2-empty">
                <i className="far fa-folder-open" />
                <p>No hay clientes que coincidan con los filtros</p>
              </td>
            </tr>
          )}

          {rows.map(row => (
            <tr key={row.id} className="cv2-row" onClick={() => onRowClick(row.id)}>
              <td className="cv2-td--mono">{row.id}</td>
              <td>
                {row.logo ? (
                  <img src={row.logo} alt="" className="cv2-logo" />
                ) : (
                  <span className="cv2-logo cv2-logo--placeholder"><i className="fas fa-building" /></span>
                )}
              </td>
              <td>
                <div className="cv2-cell-primary">{row.company_name || '—'}</div>
                {row.app_type && <div className="cv2-cell-secondary">{row.app_type}</div>}
              </td>
              <td className="cv2-td--mono">{row.nit || '—'}</td>
              <td className="cv2-td--mono">{row.user_owner_email || '—'}</td>
              <td>
                {row.plan ? (
                  <span className="cv2-chip cv2-chip--plan">{row.plan.nick_name || row.plan.name}</span>
                ) : '—'}
              </td>
              <td className="cv2-td--num">{Number(row.records_count || 0).toLocaleString()}</td>
              <td className="cv2-td--num">{formatStorage(row.size_count)}</td>
              <td>
                <span className={`cv2-chip cv2-chip--state cv2-chip--${stateClass(row.tenant_state)}`}>
                  {row.tenant_state || '—'}
                </span>
              </td>
              <td className="cv2-td--date">{formatDate(row.created_at)}</td>
              <td className="cv2-td--actions">
                <button
                  className="cv2-btn cv2-btn--ghost"
                  onClick={e => { e.stopPropagation(); onRowClick(row.id); }}
                  title="Gestionar"
                >
                  <i className="fas fa-cog" /> Gestionar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {loading && rows.length > 0 && (
        <div className="cv2-loading-overlay">
          <i className="fas fa-spinner fa-spin" /> Actualizando…
        </div>
      )}
    </div>
  );
}

function formatStorage(gb) {
  if (gb == null) return '—';
  const n = Number(gb);
  if (!Number.isFinite(n)) return '—';
  return `${n.toFixed(1)} GB`;
}

function formatDate(s) {
  if (!s) return '—';
  try {
    const d = new Date(s);
    return d.toLocaleDateString('es-CO', { year: 'numeric', month: 'short', day: '2-digit' });
  } catch { return '—'; }
}

function stateClass(state) {
  if (!state) return 'neutral';
  const s = String(state).toLowerCase();
  if (s.includes('activo') || s === 'active') return 'green';
  if (s.includes('inactivo') || s === 'inactive') return 'red';
  if (s.includes('demo')) return 'yellow';
  return 'neutral';
}
